import {api, paramEncoder} from "./repository";
const resource = "/clients";

export default {
    getAll(params) {
        return api.get(`${resource}${paramEncoder(params)}`);
    },
    store(payload) {
        return api.post(resource, payload);
    },
    getById(id, params) {
        return api.get(`${resource}/${id}${paramEncoder(params)}`);
    },
    update(payload) {
        let id = payload.id;
        return api.put(`${resource}/${id}`, payload);
    },
    destroy(id) {
        return api.delete(`${resource}/${id}`);
    },
    authorizeWithStripe(id, stripe_oauth_response_code){
        return api.post(`${resource}/${id}/authorize-with-stripe`, {stripe_oauth_response_code});
    },
    disconnectStripeAuthorization(id) {
        return api.post(`${resource}/${id}/disconnect-stripe-authorization`)
    }
}